import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import handleTouch from "../../../../../common/helpers/handleTouch";
import { getNoteOffset, isMobile, pianoParser, aspectRatio as ar } from "../../../../../common/parameters";

import player from "../../../../player";
import piano from "../../../../piano";
import Icon from "../../../../icon";

import Score from "../../../Score/score-display";
import Wrapper from "../../Wrapper";

import getBirdsPath from "../Common/getBirdsPath";
import MessageDisplay from "../Common/MessageDisplay";
import NotEdited from "../Common/NotEdited";
import play, { resetPlay } from "../Common/play";
import setUp from "../Common/setupNotation";
import getKeyOffset from "../Common/getKeyOffset";
import { checkReady, submit, failedInput } from "../Common/submitNotation";
import { selectNote, deletePitch } from "../Common/selectNoteNotation";
import getScore from "../Common/getScore";
import getScale from "../Common/getScale";
import scrollToBar from "../Common/scrollToBar";
import { SubmitButton, PlayBtn, CheckPlayBtn, Label, TopRight, DeleteButton } from "../common-style";

import Keyboard from "./Keyboard";

import { ScoreWrapper, SolfaLadderWrapper, AssetWrapper, EasterBackground, ChristmasBackground } from "./styles";
import messages from "./messages";
import { IProps, IState } from "./interfaces";
import { INotationThis } from "../Common/interfaces";
import { IBar, IPitch, IScore } from "../../../../../common/types";
import { getAccidentals } from "../../../Score/score-display/utils";
import { parseDo } from "../../../Score/methods/changeDo";

class Piano extends Component<IProps, IState> {
    static defaultProps = {
        handlePlayCount: () => {},
        handleFailCount: () => {},
    };
    play = play.bind(this as unknown as INotationThis);
    setUp = setUp.bind(this as unknown as INotationThis);
    checkReady = checkReady.bind(this as unknown as INotationThis);
    failedInput = failedInput.bind(this as unknown as INotationThis);
    submit = submit.bind(this as unknown as INotationThis);
    selectNote = selectNote.bind(this as unknown as INotationThis);
    deletePitch = deletePitch.bind(this as unknown as INotationThis);
    distribution?: number[][];
    scoreRef?: HTMLDivElement;
    frame?: HTMLDivElement;
    pauseOffset?: number;
    isCheckPlayPause?: boolean;
    firstPitch?: {
        bar: number,
        note: number,
    }
    constructor(props: IProps) {
        super(props);
        this.state = {
            submitable: false,
            submited: false,
            playing: false,
            completed: false,
            currentNote: null,
            notes: [],
            incorrectNotes: [],
            activeVoice: 0,
            failedNote: false,
            solfaNameTypes: [],
            playable: false,
            playingNote: [],
            doPos: {
                value: 0,
                alt: 0,
            }
        };
        if (props.setReset) {
            props.setReset(this.resetTask);
        }
        if (props.saveState) {
            props.saveState(this.saveState);
        }
        if (props.restoreState) {
            props.restoreState(this.restoreState);
        }
        if (props.showSolution) {
            props.showSolution(this.showSolution);
        }
    }
    resetTask = () => {
        this.setUp();

        this.setState({
            submitable: false,
            submited: false,
            completed: false,
            incorrectNotes: [],
            activeVoice: 0,
        });
    };
    saveState = () => {
        return {
            currentNote: this.state.currentNote,
            submited: this.state.submited,
            taskScore: this.state.taskScore,
            incorrectNotes: this.state.incorrectNotes,
            submitable: this.state.submitable,
            completed: this.state.completed,
            activeVoice: this.state.activeVoice,
        };
    };
    restoreState = (state: Partial<IState>) => {
        this.setState({
            currentNote: state.currentNote!,
            submited: state.submited!,
            taskScore: state.taskScore!,
            incorrectNotes: state.incorrectNotes!,
            submitable: state.submitable!,
            completed: state.completed!,
            activeVoice: state.activeVoice!,
        });
    };
    showSolution = () => {
        const score = JSON.parse(JSON.stringify(getScore(this.props.plan, this.props.task))) as IScore;
        score.settings.upperText = 3;
        delete score.settings.lowerText;
        delete score.settings.lowerText2;
        this.setState({
            taskScore: score,
            completed: true,
            submited: true,
            currentNote: null,
            activeVoice: 0,
        });
    };
    componentDidMount() {
        this.setUp();
    }

    componentWillUnmount() {
        window.removeEventListener("blur", this.blur);
        if (this.state.playing) {
            this.play();
        }
    }

    blur = () => {
        this.play();
    };

    handleInput = async (offset: number, x: 1 | -1 | null, isPiano: boolean, e: MouseEvent | TouchEvent) => {
        if (!(await handleTouch(e))) return;
        let { playing, activeVoice } = this.state;
        const {
            task,
            plan,
            task: {
                data: { showPitches },
            },
        } = this.props;
        const taskScore = this.state.taskScore!;
        const currentNote = this.state.currentNote!;
        const barsKey = "bars" + (activeVoice || "");
        let bar = (taskScore[barsKey] as IBar[])[currentNote.bar];
        const score = getScore(plan, task)!;
        let originalBar = (score[barsKey] as IBar[])[currentNote.bar];
        if (!bar) return;
        let note = bar.notes[currentNote.note];
        let originalNote = originalBar.notes[currentNote.note];
        if (!note) return;
        const accidentals = getAccidentals(taskScore);
        const doPos = parseDo(accidentals[currentNote.bar]);
        const keyOffset = getKeyOffset(doPos.value + 6) + doPos.alt;
        let noteOffset = offset - (taskScore["octave" + activeVoice] || 0) * 12 - (keyOffset + 60);
        // Octave
        let o: IPitch["o"] = 0;
        if (noteOffset < 0) o = -1;
        if (noteOffset > 11) o = 1;
        if (noteOffset === 24) o = 2;
        let { s, a } = getNoteOffset((noteOffset + 12) % 12);
        
        
        if (!playing) {
            let pianoNote =
                60 + pianoParser[s] + (a || 0) + keyOffset + ((o || 0) + (taskScore["octave" + activeVoice] || 0)) * 12;
            let loaded = piano.load(pianoNote, true, { stop: 0.6 });
            if (loaded) {
                piano.play(pianoNote, player.context.currentTime, 0.6);
            }
        }

        const originalNotePitch = originalNote.p as IPitch

        if (
            pianoParser[s] + (a || 0) === pianoParser[originalNotePitch.s] + (originalNotePitch.a || 0) &&
            o === (originalNotePitch.o || o)
        ) {
            s = originalNotePitch.s;
            a = originalNotePitch.a;
        }

        if (showPitches && originalNotePitch &&
            (originalNotePitch.s !== s || (originalNotePitch.a || 0) !== (a || 0) || (originalNotePitch.o || 0) !== (o || 0))
        ) {
            return this.failedInput();
        } else {
            this.setState({ failedNote: false });
        }

        note.p = {
            s,
            o,
            a,
        };

        if (note.tie) {
            let nextNote = bar.notes[currentNote.note + 1];
            if (!nextNote) {
                nextNote = taskScore[barsKey][currentNote.bar + 1].notes[0];
            }
            nextNote.p = { s, o, a };
        }
        let lastNote;
        do {
            lastNote = { ...currentNote };
            currentNote.note++;
            if (bar.notes.length === currentNote.note) {
                currentNote.bar++;
                bar = taskScore[barsKey][currentNote.bar] as IBar;
                currentNote.note = 0;
            }
        } while (
            (bar && bar.notes.length && bar.notes[currentNote.note].r) ||
            (taskScore[barsKey] as IBar[])[lastNote.bar].notes[lastNote.note].tie
        );
        setTimeout(() => {
            if (score[barsKey][currentNote.bar]) {
                scrollToBar(this.distribution!, this.scoreRef!, currentNote.bar);
            }
        }, 500);
        this.setState({ taskScore: { ...taskScore }, currentNote }, this.checkReady);
    };

    setRef = (ref: HTMLDivElement) => {
        this.scoreRef = ref;
    };
    setDistribution = (distribution: number[][]) => {
        this.distribution = distribution;
    };

    render() {
        const {
            incorrectNotes,
            submitable,
            submited,
            playable,
            currentNote,
            minPiano,
            maxPiano,
            playing,
            checkPlaying,
            completed,
            taskScore,
            activeVoice,
            failedNote,
            doPos,
            playingNote,
        } = this.state;
        const { task, isLow, isDemo, plan, handleHomeworkNext, isEaster, isChristmas } = this.props;
        const {
            data,
            data: { hint, withSolfa = false },
        } = task;
        const score = getScore(plan, task);
        if (!data || !playable)
            return (
                <div ref={e => (this.frame = e!)}>
                    <div>
                        <Wrapper>
                            <NotEdited />
                        </Wrapper>
                    </div>
                </div>
            );
        return (
            <div ref={e => (this.frame = e!)}>
                <Wrapper isDemo={isDemo}>
                    {isLow && (
                        <>
                            <AssetWrapper>
                                <img src={getBirdsPath("/piano/asset-01.svg")} alt="decoration" />
                            </AssetWrapper>
                        </>
                    )}
                    {isEaster && (
                        <EasterBackground />
                    )}
                    {isChristmas && (
                        <ChristmasBackground />
                    )}
                    <ScoreWrapper isLow={!!isLow} isEaster={isEaster || isChristmas}>
                        {taskScore && (
                            <Score
                                score={taskScore}
                                {...((data.showPitches || !submited) && { currentNote: currentNote! })}
                                activeVoice={activeVoice}
                                selectNote={this.selectNote}
                                playingNote={playingNote}
                                scale={getScale(plan, task) * (isLow ? 0.5425 : (isEaster || isChristmas) ? (1076 / ar.width) : 1)}
                                incorrectNotes={incorrectNotes}
                                themeColor={data.color}
                                whiteBackground={isLow}
                                showPitches={!completed && (data.showPitches || false)}
                                playing={playing}
                                checkPlaying={checkPlaying}
                                setRef={this.setRef}
                                setDistribution={this.setDistribution}
                                isEaster={isEaster || isChristmas}
                            />
                        )}
                    </ScoreWrapper>
                    <SolfaLadderWrapper className={cn(completed && "Completed")} isLow={!!isLow}>
                        <Keyboard
                            isLow={!!isLow}
                            doPos={doPos}
                            handleInput={this.handleInput}
                            min={minPiano![activeVoice]}
                            max={maxPiano![activeVoice]}
                            score={score!}
                            withSolfa={withSolfa}
                            activeVoice={activeVoice}
                            currentNote={
                                currentNote &&
                                score?.["bars" + (activeVoice || "")][currentNote.bar]?.notes?.[currentNote.note]
                            }
                            hint={
                                !!(currentNote &&
                                this.firstPitch &&
                                this.firstPitch.bar === currentNote.bar &&
                                this.firstPitch.note === currentNote.note &&
                                hint)
                            }
                        />
                    </SolfaLadderWrapper>
                    <PlayBtn
                        isLow={isLow}
                        isEaster={isEaster}
                        resetPlay={this.pauseOffset && !playing && !this.isCheckPlayPause ? resetPlay.bind(this as unknown as INotationThis) : undefined}
                        className={cn("button", "button--play")}
                        onClick={() => {
                            if (isMobile) return;
                            this.play();
                        }}
                        onTouchStart={() => {
                            if (isMobile) this.play();
                        }}
                        disabled={checkPlaying}
                    >
                        {playing && !checkPlaying ? <Icon i="pause" /> : <Icon i="play" />}
                        <Label>
                            <FormattedMessage {...messages.play} />
                        </Label>
                    </PlayBtn>
                    <TopRight isLow={isLow}>
                        {!completed && !data.showPitches && (
                            <DeleteButton
                                isLow={isLow}
                                isEaster={isEaster}
                                style={{
                                    bottom: "auto",
                                    left: "auto",
                                    padding: 16,
                                    paddingBottom: 6,
                                    paddingTop: 6,
                                    width: "auto",
                                    fontWeight: 400,
                                }}
                                className={cn("button", "button--info")}
                                onClick={() => {
                                    this.deletePitch();
                                }}
                            >
                                <FormattedMessage {...messages.delete} />
                            </DeleteButton>
                        )}
                        {!data.showPitches && (
                            <CheckPlayBtn
                                isLow={isLow}
                                isEaster={isEaster}
                                resetPlay={this.pauseOffset && this.isCheckPlayPause && !playing ? resetPlay.bind(this as unknown as INotationThis) : undefined}
                                className={cn("button", "button--check")}
                                onClick={() => this.play(false, undefined, undefined, true)}
                                disabled={(playing && !checkPlaying) || completed}
                            >
                                {checkPlaying ? <Icon i="pause" /> : <Icon i="play" />}
                                <Label>
                                    <FormattedMessage {...messages.check} />
                                </Label>
                            </CheckPlayBtn>
                        )}
                    </TopRight>
                    {submitable && !completed && !incorrectNotes.length && (
                        <SubmitButton
                            isLow={isLow}
                            isEaster={isEaster}
                            style={{
                                top: isLow ? 30 : 6,
                                bottom: "auto",
                                right: "auto",
                                left: 540,
                                paddingBottom: 5,
                                paddingTop: 5,
                            }}
                            className={cn("button")}
                            onClick={() => {
                                if (submitable) {
                                    this.submit();
                                }
                            }}
                        >
                            <FormattedMessage {...messages.submit} />
                        </SubmitButton>
                    )}
                    {completed && (
                        <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="completed" handleHomeworkNext={handleHomeworkNext} />
                    )}
                    {submited && !completed && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrect" />}
                    {failedNote && !completed && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrectNote" />}
                </Wrapper>
            </div>
        );
    }
}

export default Piano;
